<template>
    <div class="h-full flex justify-center items-center">
      <span class="loading loading-ring loading-xl w-50" />
    </div>
</template>